/* eslint-disable */
import axios from "axios";
import moment from 'moment';
import store from "../../store/index";
import jwt_decode from "jwt-decode";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
import ChangeactivityStatusPopup from "../ChangeactivityStatusPopup/ChangeactivityStatusPopup.vue"
import ChangeSchedulestatus from "../ChangeScheduleStatusPopup/ChangeScheduleStatusPopUp.vue"
import customModal from "../customModal/customModal.vue";
import CreateVideoCallSchedulePopUp from "../../components/CreateVideoCallSchedulePopUp/CreateVideoCallSchedulePopUp.vue";
import CreateScheduleCyclePopUp from "../../components/ScheduleCyclePopup/ScheduleCyclePopup.vue";
import ManageVisit from "../../components/ManageVisit/ManageVisit.vue";
import UnscheduledVisitModal from "../../components/UnscheduledVisitModal/UnscheduledVisitModal.vue";
import EnterNewEcrfTree from "./EnterNewEcrfTree.vue";
import ModifyExistingEcrfTree from "./ModifyExistingEcrfTree.vue";
import submittedforms from "./submittedforms.vue";
import manageSubjectModal from "../SiteUserDashboard/ManageSubjectModal.vue";
import editecrffrompopup from "../../components/editecrffrompopup/editecrffrompopup.vue"
// import from 'jstree'
export default {
  components: {
    VPagination,
    ChangeSchedulestatus,
    customModal,
    CreateVideoCallSchedulePopUp,
    ChangeactivityStatusPopup,
    CreateScheduleCyclePopUp,
    ManageVisit,
    UnscheduledVisitModal,
    EnterNewEcrfTree,
    ModifyExistingEcrfTree,
    submittedforms,
    manageSubjectModal,
    editecrffrompopup
  },
  data() {
    return {
      FillForm: "FillForm",
      sProp: "",
      IsDesc: true,
      defaultdate: "",
      roleprivileges: "",
      baseapi: process.env.VUE_APP_Service_URL,
      localurl: process.env.VUE_APP_redirect,
      baseUrl: `${process.env.VUE_APP_Service_URL}/management/patientschedule/`,
      currentTemplatePage: 1,
      totalTemplatePages: 1,
      overduevisits: [],
      plannedvisits: [],
      sites: [],
      showManageVisitModal: false,
      showUnscheduledVisitModal: false,
      patientId: "",
      pageplannedindex: 1,
      pageplannedsize: 10,
      recentpageplannedsize: 10,
      currentplannedPage: 1,
      totalplannedCount: 0,
      totalrecentCount: 0,
      totalplannedPages: 0,
      pageoverdueindex: 1,
      pageoverduesize: 10,
      currentoverduePage: 1,
      totaloverdueCount: 0,
      totaloverduePages: 0,
      pageformindex: 1,
      pageformsize: 10,
      currentformPage: 1,
      totalformCount: 0,
      totalformPages: 0,
      patientLists: [],
      visitobj: {},
      visitTreeObj: {},
      treeStates: {
        enter: {
          patientLists: [],
          visitobj: {},
          visitTreeObj: {},
          formDetails: {},
          visitFormObj: {},
          observationValue: {},
          visitIdObj: {},
          activityobject: {},
          categoryFlags: {},
          openedformsarray: [],
          openedpatientarray: [],
          openedsitesarray: []
        },
        modify: {
          patientLists: [],
          visitobj: {},
          visitTreeObj: {},
          formDetails: {},
          visitFormObj: {},
          observationValue: {},
          visitIdObj: {},
          activityobject: {},
          categoryFlags: {},
          openedformsarray: [],
          openedpatientarray: [],
          openedsitesarray: []
        }
      },
      formList: [],
      allFormList: [],
      selectedSubject: "",
      recentformList: [],
      currentRecentformPage: 1,
      totalformsPages: 0,
      recentpageformindex: 1,
      recentpageformsize: 10,
      SortProperty: "",
      SortOrder: 1,
      investigatorEmail: "",
      showSidePopup: {},
      plannextvisitPopup: false,
      ManageVisitPopup: false,
      oldvisitdatetDate: "",
      newvisitDate: "",
      actualVisitStartDate: "",
      actualVisitEndDate: "",
      isCompleted: false,
      showLoader: false,
      showCreateLoader: false,
      createvisitobj: {},
      managevisitobj: {},
      templateList: [],
      visitFormObj: {},
      observationValue: {},
      visitIdObj: {},
      selectedVisit: {},
      activityobject: {},
      activitystatusreload: {},
      selectedTemplate: "",
      sohowFormModal: false,
      showChangeActivity: false,
      sohowFormModalImminent: false,
      showChangeSchedule: false,
      showLoading: true,
      imminentShowLoading: true,
      recentShowLoading: true,
      formLoading: true,
      formlist: [],
      CreateVideoCallSchedulePopUp: false,
      selectedPatientId: null,
      CreateScheduleCyclePopUp: false,
      selectedCycleId: null,
      showCycleSidePopup: {},
      statusType: "",
      changeStatus: {
        studyId: "",
        visitNo: "",
        subjectNo: "",
        visitstatus: ""
      },
      visitIndex: "",
      showObservationsLoading: {},
      categoryFlags: {},
      studyRef: {},
      selectedForm: "",
      studyInfo: "",
      selectedVisitName: "",
      formIndex: "",
      scheduleId: "",
      selectedTreeKey: "enter",
      openedformsarray: [],
      openedpatientarray: [],
      openedvisitsarray: [],
      openedsitesarray: [],
      studyIdChangedHandler: null,
      showPatientModal: false,
      selectededitPatientId:"0",
      showeditecrfformpopup: false,
      ecrfformid:"",
    };
  },

  async mounted() {
    this.defaultdate = localStorage.getItem("dateformat");
    await this.setroleprivileges();
    this.investigatorEmail = jwt_decode(store.getters.getIdToken);
    this.studyIdChangedHandler = async (event) => {
      console.log("StudyIDChanged into" + event.detail.storage);
      await this.loadInitialData();
    };
    window.addEventListener("studyIdChanged", this.studyIdChangedHandler);
    await this.loadInitialData({ restoreTree: true });
  },
  unmounted() {
    if (this.studyIdChangedHandler) {
      window.removeEventListener("studyIdChanged", this.studyIdChangedHandler);
    }
    store.dispatch("setopentreeforsubmitForm", false);
  },
  computed: {
    treeHandlers() {
      return {
        getpatient: (...args) => this.getpatient(...args),
        getVisits: (...args) => this.getVisits(...args),
        goToSubjectForm: (...args) => this.goToSubjectForm(...args),
        getactivities: (...args) => this.getactivities(...args),
        setdate: (...args) => this.setdate(...args),
        showPopover: (...args) => this.showPopover(...args),
        hidePopover: (...args) => this.hidePopover(...args),
        toggleSidePopup: (...args) => this.toggleSidePopup(...args),
        closeSidePopup: (...args) => this.closeSidePopup(...args),
        openPlanNextVisitModal: (...args) => this.openPlanNextVisitModal(...args),
        openManageVisitPopup: (...args) => this.openManageVisitPopup(...args),
        openModal: (...args) => this.openModal(...args),
        openVideoCallSchedulePopup: (...args) => this.openVideoCallSchedulePopup(...args),
        openChangeStatusmodal: (...args) => this.openChangeStatusmodal(...args),
        toggleObservationFolder: (...args) => this.toggleObservationFolder(...args),
        selectDocument: (...args) => this.selectDocument(...args),
        filterTimeFormat: (...args) => this.filterTimeFormat(...args),
        getFormsByVisit: (...args) => this.getFormsByVisit(...args),
        openChangeStatusmodalforactivity: (...args) => this.openChangeStatusmodalforactivity(...args),
        gotoform: (...args) => this.gotoform(...args),
        viewform: (...args) => this.viewform(...args),
        filter: (...args) => this.filter(...args),
        ChangeTemplatePopup: (...args) => this.ChangeTemplatePopup?.(...args)
      };
    }
  },
  methods: {
    showviewecrfpopup(id){
       this.ecrfformid = id;
      this.showeditecrfformpopup = true;
    },
    closeeditecrfpopup(){
      this.showeditecrfformpopup = false;
    },
    editpatient(){
       this.selectededitPatientId = '0';
      this.showPatientModal = true;
    },
    closepatientmodel(){
      this.showPatientModal = false;
    },
    treeIdPart(value) {
      return String(value == null ? "" : value).replace(/[^A-Za-z0-9_-]/g, "-");
    },
    treeNodeId(treeKey, ...parts) {
      return [treeKey, ...parts].map(part => this.treeIdPart(part)).join("-");
    },
    treePopoverId(treeKey, ...parts) {
      return this.treeNodeId(treeKey, "popover", ...parts);
    },
    getTreeState(treeKey = "enter") {
      return this.treeStates[treeKey] || this.treeStates.enter;
    },
    async loadInitialData({ restoreTree = false } = {}) {
      await Promise.allSettled([
        this.getstudyinfo(),
        this.getoverduevisits(),
        this.getplannedvisits(),
        this.getsites(),
        this.getForms(),
        this.getAllForms(),
        this.GetRecentFormData(),
      ]);

      if (restoreTree) {
        await this.restoreopenedtree();
      }
    },
    showPopover(id) {
      document.getElementById(id)?.showPopover?.();
    },
    hidePopover(id) {
      document.getElementById(id)?.hidePopover?.();
    },
    async restoreopenedtree() {
      const iftreeopened = store.getters.getopentreeforsubmitForm;
      console.log("iftreeopened", iftreeopened);
      if (iftreeopened) {
        await this.restoresites();
        await this.restorpatients();
        await this.restoreforms();
      }

    },
    async restoresites() {
      let openedsitesarray = store.getters.getopenedsitesarray;
      console.log("openedsitesarray", openedsitesarray);
      for (const eachsites of openedsitesarray) {
        document.getElementById(this.treeNodeId("enter", "site", eachsites.siteId))?.click();
      }
    },
    async restorpatients() {
      let openedpatientsarray = store.getters.getopenedpatientarray;
      const tree = this.getTreeState("enter");
      for (const eachpatients of openedpatientsarray) {
        console.log("eachpatients", eachpatients);
        if (!tree.visitobj[eachpatients.patientId]) {
          tree.visitobj[eachpatients.patientId] = [];
        };
        await this.getVisits(eachpatients.patientId, eachpatients.index, "enter");
        let cb = document.getElementById(this.treeNodeId("enter", "patient", eachpatients.patientId));
        if (cb) {
          cb.checked = true;
        }
      }
    },
    findActivityIndex(subjectId, visitNo, visitIndex, activityid, activityorder, treeKey = "enter") {
      const tree = this.getTreeState(treeKey);
      const key = `${visitNo}_${subjectId}`;
      const arr = (tree.activityobject[key]?.[visitIndex]?.data) || [];
      return arr.findIndex(a => a.activityId === activityid && a.activityOrder === activityorder);
    },
    async restoreforms() {
      let openedformsarray = store.getters.getopenedformsarray;
      for (const eachform of openedformsarray) {
        const { subjectId, visitNo, visitIndex: vIndex, sheduleId } = eachform;
        const visitCheckboxId = this.treeNodeId("enter", "visit", sheduleId, subjectId);

        // (a) Wait until <input id="visitNo+subjectId"> exists
        await this.waitForElement(`#${CSS.escape(visitCheckboxId)}`);

        // (b) Call the same logic your @change would call:
        await this.getFormsByVisit(subjectId, visitNo, eachform.visitName, vIndex, sheduleId);
        document.getElementById(visitCheckboxId).checked = true;

        await this.$nextTick();
      }
    },
    waitForElement(selector, timeout = 5000) {
      return new Promise((resolve, reject) => {
        const start = performance.now();
        const check = () => {
          if (document.querySelector(selector)) {
            resolve();
          } else if (performance.now() - start > timeout) {
            reject(new Error(`Element ${selector} not found within ${timeout}ms`));
          } else {
            requestAnimationFrame(check);
          }
        };
        check();
      });
    },
    async setroleprivileges() {
      this.roleprivileges = await store.getters.getRolesprivilegeData;
    },
    async openFormsModal(visitNo, patientId, studyId) {
      await this.listvisitForms(visitNo, patientId, studyId);
      this.sohowFormModal = true;
    },
    async openImminentFormsModal(visitNo, patientId, studyId) {
      await this.listvisitForms(visitNo, patientId, studyId);
      this.sohowFormModalImminent = true;
    },
    async closeFormsModal() {
      this.sohowFormModal = false;
    },
    async closeImminentFormsModal() {
      this.sohowFormModalImminent = false;
    },
    openVideoCallSchedulePopup(patientId) {
      this.selectedPatientId = patientId; // Set the selected patient ID
      console.log("Patient id is", this.selectedPatientId);
      this.CreateVideoCallSchedulePopUp = true; // Open the popup
    },
    // async viewForm(formId, isPatientVisit) {
    //   this.$router.push(`/editForm/submitForm/${formId}/${isPatientVisit}`);
    // },
    async listvisitForms(visitNo, patientId, studyId) {
      const idtoken = store.getters.getIdToken;
      await
        axios.get(`${this.baseUrl}getfromsbyvisit?studyId=${studyId}&patientID=${patientId}&visitNo=${visitNo}&isRequired=true`, {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
        )
          .then((res) => {
            console.log("Visit form list is...", res);
            this.formlist = res.data.data;
          })
          .catch(err => console.log(" error in getting visit forms...", err));
    },
    async gotoform(singlevisit, autosubjectid, autositecode, visitNo, patientId) {
      if (singlevisit.visitStatus == 'Withdrawn') {
        alert("The form has already been withdrawn.");
      }
      else {
        await store.dispatch("setautofillsiteid", autositecode);
        await store.dispatch("setautofillsubjectid", autosubjectid);
        await store.dispatch("setautofillenabled", "true");
        let tempvar = {
          "Siteid": singlevisit.siteId,
          "Study_Id": singlevisit.studyId,
          "Subject_id": singlevisit.patientId,
          "Visitname": singlevisit.visitName,
          "Visitno": singlevisit.visitNo,
          "sheduleId": singlevisit.sheduleId
        }
        await store.dispatch("commitvisitdetails", tempvar);
        if (singlevisit.formId == null || singlevisit.formId == "") {

          if (singlevisit.templateId == null || singlevisit.templateId == "") {
            alert(this.$t("navigations.no template assigned"))
          }
          else {
            this.$router.push(`/form/${singlevisit.isPatientVisit}/${singlevisit.templateId}/${singlevisit.studyId}/${this.visitIdObj[visitNo + patientId]}?${this.visitIdObj[visitNo + patientId]}:0`);
          }

          // this.$router.push(`/form/${visits.templateId}/${visits.studyId}/${visits.visitid}`);
        }

        else {
          this.$router.push(`/editForm/dataEntry/${singlevisit.formId}/${singlevisit.isPatientVisit} `);
        }
      }
    },
    async gotofillform(visits, autosubjectid, autositecode) {
      if (!this.selectedTemplate) {
        alert("Please select a form.");
        return;
      }
      console.log("gotofillform visits", visits);
      await store.dispatch("setautofillsiteid", autositecode);
      await store.dispatch("setautofillsubjectid", autosubjectid);
      await store.dispatch("setautofillenabled", "true");
      const template = this.templateList.find(t => t.templateId === this.selectedTemplate);
      let tempvar = {
        "Siteid": visits.siteId,
        "Subject_id": this.selectedSubject,
        "Visitname": visits.visitName,
        "Visitno": visits.visitNo,
        "sheduleId": visits.sheduleId,
        "ActivityScheduleId": visits.actScheduleId,
        "Template_name": template.templateName,
        "Visit_id": visits.visitId
      }
      await store.dispatch("commitvisitdetails", tempvar);
      localStorage.setItem("visitDetails", JSON.stringify(tempvar));
      await store.dispatch("setfrompatientschedule", 'frompatientschedule');
      this.$router.push({
        path: `/form/${visits.isPatientVisit}/${this.selectedTemplate}/${visits.studyId}/${this.visitIdObj[visits.visitNo + visits.patientId]}?${this.visitIdObj[visits.visitNo + visits.patientId]}:0`,
        query: {
          tempObj: encodeURIComponent(JSON.stringify(tempvar))
        }
      });

    },
    async goToForms() {
      if (visits.formId == null || visits.formId == "") {
        this.gotoform();
      }
      else {
        this.EditForm();
      }
    },
    async EditForm(formId, isPatientVisit) {
      this.$router.push(`/editForm/submitForm/${formId}/${isPatientVisit}`);
    },
    async goTovisitTemplate(lists, patientId) {
      if (lists[0].visitStatus == 'Withdrawn') {
        alert("The form has already been withdrawn.");
      }
      else {
        localStorage.setItem("patid", patientId)
        await store.dispatch("setautofillsiteid", lists[0].siteCode);
        await store.dispatch("setautofillsubjectid", lists[0].patientNo);
        await store.dispatch("setautofillenabled", "true");
        if (await lists[0].templateId != null && await lists[0].templateId != "null" && await lists[0].formId == null || await lists[0].formId == "null") {
          let tempvar = {
            "Siteid": lists[0].siteId,
            "Subject_id": lists[0].patientId,
            "Study_Id": lists[0].studyId,
            "Visitname": lists[0].visitName,
            "Visitno": lists[0].visitNo,
            "sheduleId": lists[0].sheduleId
          }

          await store.dispatch("commitvisitdetails", tempvar);
          this.$router.push(`/form/${lists[0].isPatientVisit}/${lists[0].templateId}/${lists[0].studyId}/0 `);
        }
        else if (await lists[0].templateId != null && await lists[0].templateId != "null" && await lists[0].formId != null && await lists[0].formId != "null") {
          let tempvar = {
            "Siteid": lists[0].siteId,
            "Subject_id": lists[0].patientId,
            "Study_Id": lists[0].studyId,
            "Visitname": lists[0].visitName,
            "Visitno": lists[0].visitNo,
            "sheduleId": lists[0].sheduleId
          }

          await store.dispatch("commitvisitdetails", tempvar);
          this.$router.push(`/editForm/submitForm/${lists[0].formId}/${lists[0].isPatientVisit} `);
        }

        else if (await lists[0].templateId == null || await lists[0].templateId == "null") {
          alert(this.$t("navigations.no template assigned"))
        }
      }
    },
    async goToTemplate(isPatientVisit, templateid, visitid) {
      await store.dispatch("setautofillsiteid", "");
      await store.dispatch("setautofillsubjectid", "");
      await store.dispatch("setautofillenabled", "false");
      const studyid = store.getters.getStudyIs;
      localStorage.setItem("isSubjectForm", false);
      this.$router.push(`/form/${isPatientVisit}/${templateid}/${studyid}/${visitid}`);
    },
    async goToSubjectForm(form, subjectId, siteCode, patientId) {
      await store.dispatch("setautofillsiteid", siteCode);
      await store.dispatch("setautofillsubjectid", subjectId);
      await store.dispatch("setautofillenabled", "true");
      let tempvar = {
        "Siteid": siteCode,
        "Subject_id": patientId,
        "Study_Id": form.studyId || store.getters.getStudyIs,
        "Visitname": "",
        "Visitno": "",
        "sheduleId": ""
      };
      await store.dispatch("commitvisitdetails", tempvar);
      localStorage.setItem("isSubjectForm", true);
      this.$router.push(`/form/false/${form.templateId}/${store.getters.getStudyIs}/0`);
    },
    async isNumber(n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    },
    async viewform(id, siteid, subid, patid, studyid) {
      console.log("siteid, subid = ", siteid, subid);
      if (siteid != null || subid != null) {
        console.log("siteid, subid = ", siteid, subid);
        await store.dispatch("setautofillenabled", "true");
      }
      else {
        await store.dispatch("setautofillenabled", "false");
      }
      let tempvar = {
        "Siteid": "",
        "Subject_id": patid,
        "Study_Id": studyid,
      }

      await store.dispatch("commitvisitdetails", tempvar);
      this.ecrfformid = id;
      // this.$router.push(`/editecrffrom/dataEntry/${id}/0`);
      this.showeditecrfformpopup = true;
      
    },
    async setFontSize(el) {
      var fontSize = el.val();

      if (isNumber(fontSize) && fontSize >= 0.5) {
        $('body').css({ fontSize: fontSize + 'em' });
      } else if (fontSize) {
        el.val('1');
        $('body').css({ fontSize: '1em' });
      }
    },
    async itemClick(node) {
      console.log(node.model.text + ' clicked !')
    },

    filter(data) {
      if (data) {
        return moment(data).utc().format(this.defaultdate);
      }
      console.log(data);
    },
    setdate(visitobj) {
      let datereturn = "";
      if (visitobj.visitStatus == "Completed" || visitobj.visitStatus == "In Progress") {
        datereturn = this.filter(visitobj.actualVisitStartDate)
      }
      else {
        datereturn = this.filter(visitobj.visitDate);
      }
      return datereturn;
    },
    filterMonth(date) {
      if (date) {
        //console.log("dateeeeeeeeee",date)
        return moment(date).format('DD-MMM-YYYY')
      }
    },
    SortSelectforms(sortProp, id) {
      console.log('SortPropChanged');
      const selectedElement = document.getElementById(id)
      const selectedElementID = document.getElementById(id).id
      if (sortProp != null && id == selectedElementID) {
        this.sortDesc = !this.sortDesc
        if (this.SortOrder == 0) {
          if (selectedElement.classList.contains("sortDesc")) {
            return
          }
          else if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc")
            selectedElement.classList.add("sortDesc")
          }
          else selectedElement.classList.add("sortDesc")
        }
        else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc")
            selectedElement.classList.add("sortAsc")
          }
          else if (selectedElement.classList.contains("sortAsc")) {
            return
          }
          else selectedElement.classList.add("sortAsc")
        }
      }
      this.pageindex = 1;
      this.currentPage = 1;
      this.SortProperty = sortProp;
      this.SortOrder = this.SortOrder == 0 ? 1 : 0;
      this.GetRecentFormData();
    },
    async GetRecentFormData() {
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;
      this.recentShowLoading = true
      await axios
        .get(`${this.baseapi}/forms/ecrfsource/getpaginatedrecentecrf?studyId=${stdid}&userEmail=${this.investigatorEmail.email}&pageindex=${this.recentpageformindex}&pagesize=${this.recentpageformsize}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((response) => {
          if (response.data) {
            this.recentformList = response.data.results
            this.totalrecentCount = response.data.totalCount;

            this.totalformsPages = parseInt(this.totalrecentCount / this.recentpageplannedsize);
            if (this.totalrecentCount % this.recentpageplannedsize != 0) {
              this.totalformsPages = this.totalformsPages + 1;
            }


            this.recentShowLoading = false
          }
          else {
            this.recentShowLoading = false
          }
        })

        .catch((err) => {
          this.recentShowLoading = false
          console.log(err);
        });
    },
    SortSelected(sortProp, id) {
      console.log('SortPropChanged');
      const selectedElement = document.getElementById(id)
      const selectedElementID = document.getElementById(id).id
      if (sortProp != null && id == selectedElementID) {
        if (this.IsDesc == true) {
          if (selectedElement.classList.contains("sortDesc")) {
            return
          }
          else if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc")
            selectedElement.classList.add("sortDesc")
          }
          else selectedElement.classList.add("sortDesc")
        }
        else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc")
            selectedElement.classList.add("sortAsc")
          }
          else if (selectedElement.classList.contains("sortAsc")) {
            return
          }
          else selectedElement.classList.add("sortAsc")
        }
      }
      this.pageindex = 1;
      this.currentPage = 1;
      this.sProp = sortProp;
      this.IsDesc = this.IsDesc == true ? false : true;
      this.getoverduevisits();
    },
    async getoverduevisits() {
      this.showLoading = true
      this.overduevisits = []
      const currentstudyid = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      await axios
        .get(`${this.baseapi}/management/patientschedule/getshedules?Investigator=${this.investigatorEmail.name}&StudyId=${currentstudyid}&VisitStatus=Overdue&PageNo=${this.pageoverdueindex}&ItemCount=${this.pageoverduesize}&sortprop=${this.sProp}&isDes=${this.IsDesc}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.overduevisits = res.data.data;
          console.log("Overdue visits are", this.overduevisits)
          this.totaloverdueCount = res.data.totalCount;
          this.totaloverduePages = parseInt(res.data.totalCount / this.pageoverduesize);
          if (this.totaloverdueCount % this.pageoverduesize != 0) {
            this.totaloverduePages = this.totaloverduePages + 1;
          }
          this.showLoading = false
        })
        .catch((err) => {
          this.showLoading = false
          console.log(err);
        });
    },
    SortSelect(sortProp, id) {
      console.log('SortPropChanged');
      const selectedElement = document.getElementById(id)
      const selectedElementID = document.getElementById(id).id
      if (sortProp != null && id == selectedElementID) {
        if (this.IsDesc == true) {
          if (selectedElement.classList.contains("sortDesc")) {
            return
          }
          else if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc")
            selectedElement.classList.add("sortDesc")
          }
          else selectedElement.classList.add("sortDesc")
        }
        else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc")
            selectedElement.classList.add("sortAsc")
          }
          else if (selectedElement.classList.contains("sortAsc")) {
            return
          }
          else selectedElement.classList.add("sortAsc")
        }
      }
      this.pageindex = 1;
      this.currentPage = 1;
      this.sProp = sortProp;
      this.IsDesc = this.IsDesc == true ? false : true;
      this.getplannedvisits();
    },
    async getplannedvisits() {
      this.plannedvisits = []
      const currentstudy = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      this.imminentShowLoading = true
      await axios
        .get(`${this.baseapi}/management/patientschedule/getshedules?Investigator=${this.investigatorEmail.name}&StudyId=${currentstudy}&VisitStatus=Imminent&PageNo=${this.pageplannedindex}&ItemCount=${this.pageplannedsize}&sortprop=${this.sProp}&isDes=${this.IsDesc}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.plannedvisits = res.data.data;
          this.totalplannedCount = res.data.totalCount;
          this.totalplannedPages = parseInt(res.data.totalCount / this.pageplannedsize);
          if (this.totalplannedCount % this.pageplannedsize != 0) {
            this.totalplannedPages = this.totalplannedPages + 1;
          }
          this.imminentShowLoading = false
        })
        .catch((err) => {
          this.imminentShowLoading = false
        });
    },
    async getsites() {
      const currentstudyid = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseapi}/management/site/getallsitesbyuser?studyId=${currentstudyid}&getAll=false&sortProperty=siteCode&IsDes=false`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.sites = res.data;
          console.log("Sites are", this.sites)
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getpatient(siteId, index, treeKey = "enter") {
      const tree = this.getTreeState(treeKey);
      let newopenedpatent = {
        "siteId": siteId,
        "index": index
      }
      const existingIndex = tree.openedsitesarray.findIndex(
        item => item.siteId === siteId && item.index === index
      );

      if (existingIndex !== -1) {
        tree.openedsitesarray.splice(existingIndex, 1);
      }
      else {
        tree.openedsitesarray.push(newopenedpatent);
      }
      if (treeKey === "enter") {
        this.openedsitesarray = tree.openedsitesarray;
        await store.dispatch("setopenedsitesarray", tree.openedsitesarray);
      }
      tree.patientLists[index] = [];
      const idtoken = store.getters.getIdToken;
      const currentstudyid = store.getters.getStudyIs;
      await axios
        .get(
          `${this.baseapi}/management/patient/listpatient?SiteId=${siteId}&Studyid=${currentstudyid}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then(async (res) => {
          let data = res.data.results;
          await data.forEach(patientdata => {
            tree.visitobj[patientdata.patientId] = [];
            tree.formDetails[patientdata.patientId] = [];
          });
          tree.patientLists[index] = data;
          console.log("patient list is", tree.visitobj)
        });
    },
    async setvisitobj(data, treeKey = "enter") {
      const tree = this.getTreeState(treeKey);
      console.log("set visit function");
      console.log("patient list is", data);
      data.forEach(patientdata => {
        tree.visitobj[patientdata.patientId] = [];
      });
      console.log(tree.visitobj);
    },
    async getVisits(patientId, index, treeKey = "enter") {
      const tree = this.getTreeState(treeKey);
      this.selectedSubject = patientId;
      this.selectedTreeKey = treeKey;
      console.log("patientId, index", patientId, index);
      let openedvisit = {
        "patientId": patientId,
        "index": index
      }
      const existingIndex = tree.openedpatientarray.findIndex(
        item => item.patientId === patientId && item.index === index
      );

      if (existingIndex !== -1) {
        // It’s already in the array → remove it
        tree.openedpatientarray.splice(existingIndex, 1);
      } else {
        tree.openedpatientarray.push(openedvisit);
      }
      if (treeKey === "enter") {
        this.openedpatientarray = tree.openedpatientarray;
        await store.dispatch("setopenedpatientarray", tree.openedpatientarray);
      }
      if (!tree.visitobj[patientId]) {
        tree.visitobj[patientId] = [];
      }
      tree.visitobj[patientId][index] = [];
      if (treeKey === "modify") {
        tree.formDetails[patientId] = [];
        await this.getModifyFormDetails(patientId);
        return;
      }
      const idtoken = store.getters.getIdToken;
      console.log("patient ID is", patientId)

      await axios
        .get(
          `${this.baseapi}/management/patientschedule/getpatientshedule?patientID=${patientId}&ItemCount=500&sortprop=VisitNo`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          tree.visitobj[patientId][index] = res.data.data;
          tree.visitTreeObj[patientId] = this.buildVisitTree(res.data.data);
          console.log("The visit list is", tree.visitobj)
        })
        .catch((err) => {
          console.log("error is", err);
        })
      this.displayTable = true
    },
    async getModifyFormDetails(patientId) {
      const tree = this.getTreeState("modify");
      const idtoken = store.getters.getIdToken;

      try {
        const res = await axios.get(
          `${this.baseapi}/forms/forms/formdeatils?subjectId=${patientId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );
        tree.formDetails[patientId] = Array.isArray(res.data)
          ? res.data
          : res.data?.data || res.data?.results || [];
      } catch (err) {
        console.log("error while getting subject form details", err);
      }
    },
    getNestedNodeIndex(parentIndex, childIndex) {
      return `${parentIndex}-${childIndex}`;
    },
    buildVisitTree(visits) {
      const tree = [];
      const cycleMap = {};
      const studyPhaseMap = {};
      const studyPhaseCycleMap = {};

      visits.forEach((visit, index) => {
        visit.__visitIndex = index;

        if (hasStudyPhase(visit)) {
          const key = visit.studyPhaseId || visit.studyPhase;

          if (!studyPhaseMap[key]) {
            studyPhaseMap[key] = {
              type: "studyPhase",
              studyPhase: visit.studyPhase,
              studyPhaseId: visit.studyPhaseId,
              displayText: visit.studyPhase,
              visits: []
            };
            studyPhaseCycleMap[key] = {};
            tree.push(studyPhaseMap[key]);
          }

          if (visit.isCycleVisit) {
            const cycleKey = getCycleKey(visit);

            if (!studyPhaseCycleMap[key][cycleKey]) {
              studyPhaseCycleMap[key][cycleKey] = {
                type: "cycle",
                cycleName: visit.cycleName,
                occurence: visit.occurence,
                cycleId: visit.cycleId,
                displayText: `${visit.cycleName} - ${visit.occurence}`,
                visits: []
              };
              studyPhaseMap[key].visits.push(studyPhaseCycleMap[key][cycleKey]);
            }

            studyPhaseCycleMap[key][cycleKey].visits.push(visit);
          } else {
            studyPhaseMap[key].visits.push(visit);
          }
        } else if (visit.isCycleVisit) {
          const key = getCycleKey(visit);

          if (!cycleMap[key]) {
            cycleMap[key] = {
              type: "cycle",
              cycleName: visit.cycleName,
              occurence: visit.occurence,
              cycleId: visit.cycleId,
              displayText: `${visit.cycleName} - ${visit.occurence}`,
              visits: []
            };
            tree.push(cycleMap[key]);
          }

          cycleMap[key].visits.push(visit);
        } else {
          tree.push({
            type: "visit",
            visit
          });
        }
      });

      Object.values(cycleMap).forEach(cycle => {
        sortVisits(cycle.visits);
      });

      Object.values(studyPhaseMap).forEach(phase => {
        phase.visits.forEach(entry => {
          if (entry?.type === "cycle" && Array.isArray(entry.visits)) {
            sortVisits(entry.visits);
          }
        });
        sortStudyPhaseEntries(phase.visits);
      });

      tree.sort(compareTreeNodes);

      return tree;

      function hasStudyPhase(visit) {
        return visit?.studyPhase != null && String(visit.studyPhase).trim() !== "";
      }

      function getCycleKey(visit) {
        const cycleIdPart =
          visit.cycleId != null && visit.cycleId !== ""
            ? visit.cycleId
            : visit.cycleName || "cycle";
        return `${cycleIdPart}-${visit.occurence}`;
      }

      function sortVisits(visitList) {
        visitList.sort(compareVisits);
      }

      function sortStudyPhaseEntries(entryList) {
        entryList.sort((a, b) => {
          return compareVisits(getEntryVisit(a), getEntryVisit(b));
        });
      }

      function getEntryVisit(entry) {
        if (!entry) return null;
        if (entry.type === "cycle") {
          return Array.isArray(entry.visits) && entry.visits.length
            ? entry.visits[0]
            : null;
        }
        if (entry.type === "visit" && entry.visit) {
          return entry.visit;
        }
        return entry;
      }

      function compareVisits(a, b) {
        if (!a && !b) return 0;
        if (!a) return 1;
        if (!b) return -1;

        const dateA = getVisitSortDate(a);
        const dateB = getVisitSortDate(b);

        if (dateA && dateB) {
          const diff = dateA - dateB;
          if (diff !== 0) return diff;
        } else if (dateA && !dateB) {
          return -1;
        } else if (!dateA && dateB) {
          return 1;
        }

        const dayA = extractDay(a.visitNo);
        const dayB = extractDay(b.visitNo);

        if (dayA !== null && dayB !== null) return dayA - dayB;

        return String(a.visitNo || "").localeCompare(String(b.visitNo || ""));
      }

      function compareTreeNodes(a, b) {
        const result = compareVisits(getNodeVisit(a), getNodeVisit(b));
        if (result !== 0) return result;

        const rankA = getNodeRank(a);
        const rankB = getNodeRank(b);
        if (rankA !== rankB) return rankA - rankB;

        return String(getNodeLabel(a)).localeCompare(String(getNodeLabel(b)));
      }

      function getNodeVisit(node) {
        if (!node) return null;
        if (node.type === "visit") return node.visit || null;
        if (node.type === "cycle") {
          return Array.isArray(node.visits) && node.visits.length
            ? node.visits[0]
            : null;
        }
        if (node.type === "studyPhase") {
          return Array.isArray(node.visits) && node.visits.length
            ? getEntryVisit(node.visits[0])
            : null;
        }
        return null;
      }

      function getNodeRank(node) {
        if (!node) return 99;
        if (node.type === "studyPhase") return 0;
        if (node.type === "visit") return 1;
        if (node.type === "cycle") return 2;
        return 99;
      }

      function getNodeLabel(node) {
        if (!node) return "";
        if (node.type === "studyPhase") return node.studyPhase || "";
        if (node.type === "visit") {
          const visit = node.visit || {};
          return `${visit.visitNo || ""}-${visit.visitName || ""}`;
        }
        if (node.type === "cycle") return node.displayText || node.cycleName || "";
        return "";
      }

      function extractDay(visitNo) {
        const match = visitNo?.match(/D(\d+)/i);
        return match ? parseInt(match[1], 10) : null;
      }

      function getVisitSortDate(visit) {
        if (!visit) return null;
        const raw =
          visit.visitStatus === "Completed" || visit.visitStatus === "In Progress"
            ? visit.actualVisitStartDate
            : visit.visitDate;
        if (!raw) return null;
        const dt = new Date(raw);
        return isNaN(dt.getTime()) ? null : dt;
      }
    },
    loadTemplate: function (page) {
      this.currentTemplatePage = page;
      this.getForms();
    },
    async getForms() {
      const currentstudyid = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;
      this.formLoading = true
      const head = {
        headers: {
          Authorization: "Bearer " + idtoken,
          "Content-Type": "application/json",
        },
      }
      await axios.get(`${this.baseapi}/forms/template/listtemplate?IsPrivileged=true&StudyID=${currentstudyid}&Status=Approved&pageindex=${this.currentTemplatePage}&pagesize=5&SortProperty=templateName&SortOrder=0`, head)

        .then((res) => {
          console.log("template details ", res.data);
          this.formList = res.data.results;

          let totalCount = res.data.totalCount;
          this.totalTemplatePages = parseInt(totalCount / 5);
          if (totalCount % 5 != 0) {
            this.totalTemplatePages = this.totalTemplatePages + 1;
          }
          this.formLoading = false
        })
        .catch(err => this.formLoading = false);
    },
    async listTemplate() {
      const idtoken = store.getters.getIdToken;
      const currentstudyid = store.getters.getStudyIs;
      await axios.get(`${this.baseapi}/forms/template/listtemplate?IsPrivileged=true&Status=Approved&StudyID=${currentstudyid}&&SortProperty=templateName&SortOrder=0 `,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      ).then((res) => {
        console.log("Study template list is...", res.data);
        this.templateList = res.data.results;
      })
        .catch(err => console.log("error while getting template list", err))
    },
    async getAllForms() {
      const idtoken = store.getters.getIdToken;
      const currentstudyid = store.getters.getStudyIs;
      await axios.get(`${this.baseapi}/forms/template/listtemplate?IsPrivileged=true&Status=Approved&StudyID=${currentstudyid}&SortProperty=templateName&SortOrder=0`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      ).then((res) => {
        this.allFormList = res.data.results;
      })
        .catch(err => console.log("error while getting all forms list", err));
    },
    toggleSidePopup(sIndex, pIndex, vIndex, treeKey = "enter") {
      console.log("Toggle", sIndex, this.showSidePopup);

      // Initialize arrays if they don't exist
      if (!this.showSidePopup[treeKey]) {
        this.showSidePopup[treeKey] = [];
      }
      if (!this.showSidePopup[treeKey][sIndex]) {
        this.showSidePopup[treeKey][sIndex] = [];
      }
      if (!this.showSidePopup[treeKey][sIndex][pIndex]) {
        this.showSidePopup[treeKey][sIndex][pIndex] = [];
      }

      // Toggle the value
      if (typeof this.showSidePopup[treeKey][sIndex][pIndex][vIndex] === 'undefined') {
        this.showSidePopup[treeKey][sIndex][pIndex][vIndex] = false;
      }
      this.showSidePopup[treeKey][sIndex][pIndex][vIndex] =
        !this.showSidePopup[treeKey][sIndex][pIndex][vIndex];
    }
    ,
    closeSidePopup(sIndex, pIndex, vIndex, treeKey = "enter") {
      if (
        this.showSidePopup[treeKey] &&
        this.showSidePopup[treeKey][sIndex] &&
        this.showSidePopup[treeKey][sIndex][pIndex]
      ) {
        this.showSidePopup[treeKey][sIndex][pIndex][vIndex] = false;
      }
    },
    toggleCycleSidePopup(sIndex, pIndex, nodeIndex) {
      if (!this.showCycleSidePopup[sIndex]) {
        this.showCycleSidePopup[sIndex] = {};
      }
      if (!this.showCycleSidePopup[sIndex][pIndex]) {
        this.showCycleSidePopup[sIndex][pIndex] = {};
      }
      this.showCycleSidePopup[sIndex][pIndex][nodeIndex] =
        !this.showCycleSidePopup[sIndex][pIndex][nodeIndex];
    },
    closeCycleSidePopup(sIndex, pIndex, nodeIndex) {
      if (
        this.showCycleSidePopup[sIndex] &&
        this.showCycleSidePopup[sIndex][pIndex]
      ) {
        this.showCycleSidePopup[sIndex][pIndex][nodeIndex] = false;
      }
    },
    async closeManageVisitModal() {
      this.ManageVisitPopup = false;
    },
    async closeplannextvisitModal() {
      this.plannextvisitPopup = false;
    },
    async openPlanNextVisitModal(visitobj, patientIndex, treeKey = "enter") {
      this.oldvisitdatetDate = "";
      this.newvisitDate = "";
      this.createvisitobj = {
        ...visitobj,
        __patientIndex: patientIndex != null ? patientIndex : 0,
        __treeKey: treeKey
      };

      if (visitobj.visitDate == null || visitobj.visitDate == "") {
        this.oldvisitdatetDate = null;
      } else {
        this.oldvisitdatetDate = moment(visitobj.visitDate).format("YYYY-MM-DDTHH:mm");
      }
      this.plannextvisitPopup = true;
    },
    async changeVisitDate() {
      const patientIndex =
        this.createvisitobj.__patientIndex != null
          ? this.createvisitobj.__patientIndex
          : 0;
      const tree = this.getTreeState(this.createvisitobj.__treeKey || "enter");
      const schedules =
        tree.visitobj?.[this.createvisitobj.patientId]?.[patientIndex] || [];
      const selectedSchedule = schedules.find(
        (s) => s.visitName === this.createvisitobj.visitName
      );
      if (selectedSchedule?.visitDate) {
        this.oldvisitdatetDate = moment(selectedSchedule.visitDate).format("YYYY-MM-DDTHH:mm");
      }
    },
    async Createnewvisitfun(payload) {
      if (!this.newvisitDate) {
        alert("Please enter New Visit Date");
        return;
      }

      this.showLoader = true;
      const idtoken = store.getters.getIdToken;

      try {
        await axios.put(
          `${this.baseapi}/management/patientschedule/activatenextvisit`,
          {
            studyId: payload.studyId,
            subjectId: payload.patientId,
            visitNumber: payload.visitNo,
            oldVisitDate: this.oldvisitdatetDate,
            newVisitDate: this.newvisitDate,
            preVisitDate: this.preVisitDate || null,
            postVisitDate: this.postVisitDate || null
          },
          {
            headers: {
              Authorization: "Bearer " + idtoken
            }
          }
        );

        this.plannextvisitPopup = false;
        const patientIndex =
          payload.__patientIndex != null ? payload.__patientIndex : 0;
        const treeKey = payload.__treeKey || "enter";
        alert("Updated Successfully")
        await this.getVisits(payload.patientId, patientIndex, treeKey);
      } catch (err) {
        console.log("Error in planning next visit", err);
      } finally {
        this.showLoader = false;
      }
    },
    async openManageVisitPopup(visitobj, patientIndex, treeKey = "enter") {
      console.log("visit object is ", visitobj);
      this.isCompleted = false;

      if (visitobj.actualVisitStartDate == null || visitobj.actualVisitStartDate == "") {
        this.actualVisitStartDate = "";
      } else {
        this.actualVisitStartDate = visitobj.actualVisitStartDate;
      }

      if (visitobj.actualVisitEndDate == null || visitobj.actualVisitEndDate == "") {
        this.actualVisitEndDate = "";
      } else {
        this.actualVisitEndDate = visitobj.actualVisitEndDate;
      }

      this.managevisitobj = {
        ...visitobj,
        __patientIndex: patientIndex != null ? patientIndex : 0,
        __treeKey: treeKey
      };
      this.ManageVisitPopup = true;
    },
    async updateactualvisitdates(payload) {
      if (this.actualVisitStartDate == "") {
        alert("Please enter Visit Start Date");
        return;
      }

      this.showCreateLoader = true;
      if (this.actualVisitEndDate == "") {
        this.actualVisitEndDate = null;
      }

      if (this.isCompleted == false) {
        this.actualVisitEndDate = null;
      }

      const idtoken = store.getters.getIdToken;

      try {
        await axios.put(
          `${this.baseapi}/management/patientschedule/updateactualvisitdates`,
          {
            studyId: payload.studyId,
            subjectId: payload.patientId,
            visitNumber: payload.visitNo,
            plannedVisitDate: payload.visitDate,
            actualVisitStartDate: this.actualVisitStartDate,
            actualVisitEndDate: this.actualVisitEndDate,
            visitStatus: this.isCompleted ? "Completed" : "In Progress"
          },
          {
            headers: {
              Authorization: "Bearer " + idtoken
            }
          }
        );

        this.ManageVisitPopup = false;
        const patientIndex =
          payload.__patientIndex != null ? payload.__patientIndex : 0;
        const treeKey = payload.__treeKey || "enter";
        await this.getVisits(payload.patientId, patientIndex, treeKey);
      } catch (err) {
        console.log("Error updating actual visit dates", err);
      } finally {
        this.showCreateLoader = false;
      }
    },
    openScheduleCyclePopup(cycleId, patientId) {
      this.selectedPatientId = patientId;
      this.selectedCycleId = cycleId;
      this.CreateScheduleCyclePopUp = true;
    },
    async openModal(visit, subjectId, siteCode, visitNo, popoverId) {
      if (visit.withdrawnDate) {
        alert("You cannot add new forms to a withdrawn visit");
      }
      else {
        console.log("Open Modal", visit, subjectId, siteCode)
        if (popoverId) {
          this.closePopover(popoverId);
        }
        this.selectedVisit.visit = visit;
        this.selectedVisit.subjectId = subjectId;
        this.selectedVisit.siteCode = siteCode;
        console.log("selected visit is ", this.selectedVisit);
        // this.selectedmodeltemplate = "";
        // this.selectedvisitid = visitid;
        await this.listTemplate();
        const modalWrapper = document.querySelector(".modal-wrapper");
        modalWrapper.classList.add("active");
      }
    },

    closeModal() {
      // this.selectedmodeltemplate = "";
      const modalWrapper = document.querySelector(".modal-wrapper");
      modalWrapper.classList.remove("active");
    },
    async getstudyinfo() {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseapi}/management/study/getbyid?id=${store.getters.getStudyIs}&api-version=1.0`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.studyInfo = res.data;
          this.studyRef = res.data.studyRef
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getFormsByVisit(
      subjectId,
      visitNo,
      visitName,
      visitIndex,
      sheduleId,
      activityindex,
      activityid,
      activityorder,
      treeKey = "enter"
    ) {
      const tree = this.getTreeState(treeKey);
      // (unchanged) toggle checkbox safely
      if (activityid != null && activityorder != null) {
        const cbId = this.treeNodeId(treeKey, "activity", activityid, subjectId, visitNo, activityorder);
        const el = document.getElementById(cbId);
        if (el) el.checked = !el.checked;
      }

      // (unchanged) persist open state
      const opened = { sheduleId, subjectId, visitNo, visitName, visitIndex };
      if (activityid != null && activityorder != null) {
        opened.activityid = activityid;
        opened.activityorder = activityorder;
      }
      const existingIndex = tree.openedformsarray.findIndex(item =>
        item.sheduleId === sheduleId &&
        item.subjectId === subjectId &&
        item.visitNo === visitNo &&
        item.visitName === visitName &&
        item.visitIndex === visitIndex &&
        (
          (opened.activityid == null && item.activityid == null) ||
          (opened.activityid != null &&
            item.activityid === opened.activityid &&
            item.activityorder === opened.activityorder)
        )
      );
      if (existingIndex !== -1) tree.openedformsarray.splice(existingIndex, 1);
      else tree.openedformsarray.push(opened);
      if (treeKey === "enter") {
        this.openedformsarray = tree.openedformsarray;
        await store.dispatch("setopenedformsarraysubschedule", tree.openedformsarray);
      }

      // (unchanged) data prep
      const key = visitNo + subjectId;
      if (!tree.visitFormObj[key]) tree.visitFormObj[key] = [];

      if (activityindex == null && activityid != null) {
        activityindex = this.findActivityIndex(subjectId, visitNo, visitIndex, activityid, activityorder, treeKey);
        if (activityindex < 0) activityindex = 0;
      }
      if (activityindex == null) activityindex = 0;
      tree.visitFormObj[key][activityindex] = [];

      // --- CHANGED PART: build request without `??` and without manual string concat
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;

      try {
        const res = await axios.get(
          `${this.baseapi}/management/patientschedule/getfromsbyvisit`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
            params: {
              studyId: stdid,
              patientID: subjectId,
              visitNo: visitNo,
              visitName: visitName,
              activityId: activityid == null ? "" : activityid,
              activityOrder: activityorder == null ? "" : activityorder,
            },
          }
        );
        tree.visitFormObj[key][activityindex] = res.data.data;
      } catch (err) {
        console.log("error while getting visit forms list", err);
      }
    },
    async getactivities(subjectId, visitNo, visitName, visitIndex, sheduleId, siteCode, patientNo, treeKey = "enter") {
      const tree = this.getTreeState(treeKey);
      const visitKey = `${visitNo}_${subjectId}`;
      const openedforms = { sheduleId, subjectId, visitNo, visitName, visitIndex };

      const existingIndex = tree.openedformsarray.findIndex(
        item => item.sheduleId === sheduleId && item.subjectId === subjectId &&
          item.visitNo === visitNo && item.visitName === visitName &&
          item.visitIndex === visitIndex
      );

      if (existingIndex !== -1) {
        tree.openedformsarray.splice(existingIndex, 1);
      } else {
        tree.openedformsarray.push(openedforms);
      }

      if (treeKey === "enter") {
        this.openedformsarray = tree.openedformsarray;
        await store.dispatch("setopenedformsarraysubschedule", tree.openedformsarray);
      }
      this.visitIndex = visitIndex;
      this.selectedTreeKey = treeKey;

      if (!tree.activityobject[visitKey]) {
        tree.activityobject[visitKey] = [];
      }

      tree.observationValue[visitKey] = false;
      tree.activityobject[visitKey][visitIndex] = [];

      const idtoken = store.getters.getIdToken;
      const currentstudyid = store.getters.getStudyIs;
      try {
        const res = await axios.get(
          `${this.baseapi}/management/patientschedule/getactivitynames?subjectId=${subjectId}&visitNo=${visitNo}&studyId=${currentstudyid}&IsRequired=true`,
          {
            headers: {
              Authorization: `Bearer ${idtoken}`,
              "Content-Type": "application/json",
            },
          }
        );
        tree.activityobject[visitKey][visitIndex] = res.data.data;
        this.getVisitId(visitNo, subjectId, treeKey);
        if (siteCode && patientNo) {
          this.toggleObservationFolder(siteCode, patientNo, visitName, visitNo, subjectId, treeKey);
        }
      } catch (err) {
        console.error("Error while getting visit forms list", err);
      }
    },
    async getVisitId(visitNo, subjectId, treeKey = "enter") {
      const tree = this.getTreeState(treeKey);
      tree.visitIdObj[visitNo + subjectId] = ""
      this.visitIdObj[visitNo + subjectId] = ""
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;
      await axios.get(`${this.baseapi}/management/visit/listvisit?VisitNo=${visitNo}&studyId=${stdid}`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      ).then((res) => {
        tree.visitIdObj[visitNo + subjectId] = res.data.results[0].visitId;
        this.visitIdObj[visitNo + subjectId] = res.data.results[0].visitId;
      })
        .catch(err => console.log("error while getting visit forms list", err)

        )
    },
    async listVisitForms(siteId, subjectId, visitNo, treeKey = "enter") {
      const tree = this.getTreeState(treeKey);
      tree.visitFormObj[visitNo] = [];
      const idtoken = store.getters.getIdToken;
      const stdid = store.getters.getStudyIs;
      await axios.get(`${this.baseapi}/forms/forms/getformsbyids?studyid=${stdid}&siteid=${siteId}&subjectid=${subjectId}&visitno=${visitNo}`,
        {
          headers: {
            Authorization: "Bearer " + idtoken,
            "Content-Type": "application/json",
          },
        }
      ).then((res) => {
        tree.visitFormObj[visitNo] = res.data;
        console.log("Visit form list is...", tree.visitFormObj);
        console.log("data is ", tree.visitFormObj[visitNo])
      })
        .catch(err => console.log("error while getting visit forms list", err)

        )
    },
    selectDocument(siteCode, patientId, doc, visitName, subjectId, siteId) {
      sessionStorage.setItem('FHIRpatient', JSON.stringify(doc));
      this.$router.push(`/FHIRpage/${siteCode}/${patientId}/${visitName}/${subjectId}/${siteId}`)
    },
    filterTimeFormat(data) {
      if (data) {
        return data.replace(/:00\+00:00$/, '');
      }
    },
    async toggleObservationFolder(siteCode, subjectCode, visitCode, visitNo, patientId, treeKey = "enter") {
      const tree = this.getTreeState(treeKey);
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseapi}/fhir-service/fhir/observations?StudyRef=${this.studyRef}&SiteCode=${siteCode}&Subjects=${subjectCode}&VisitCodes=${visitCode}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        ).then((res) => {
          if (res.data && res.data.length != 0 && res.data != 'Visits Not Found') {
            tree.observationValue[visitNo + patientId] = true
            tree.categoryFlags[visitNo + patientId] = Object.values(
              res.data.reduce((acc, doc) => {
                const document = doc.resource;
                const id = doc.resource.id
                const category = doc.resource.category[0].coding[0].display;
                const codeText = doc.resource.code.text ? doc.resource.code.text : doc.resource.code.coding[0].display; // Handle missing `text`
                const effectiveDateTime = doc.resource.effectiveDateTime || null;

                // If the category already exists, add the code to its array
                if (!acc[category]) {
                  acc[category] = {
                    category: category,
                    code: [],
                    effectiveDateTime: [],
                    flag: false,
                    document: [],
                    id: [],
                    idSet: new Set(), // Track unique IDs
                  };
                }   // Push codeText to the array (allowing duplicates)
                if (id && !acc[category].idSet.has(id)) {
                  acc[category].idSet.add(id);
                  acc[category].id.push(id);

                  if (codeText) {
                    acc[category].code.push(codeText);
                  }
                  if (effectiveDateTime) {
                    acc[category].effectiveDateTime.push(effectiveDateTime);
                  }
                  if (document) {
                    acc[category].document.push(document);
                  }
                }

                return acc;

              }, {})


            );
            const vitalSignsCategory = tree.categoryFlags[visitNo + patientId].find(category => category.category === "Vital Signs" || category.category === "vital signs"
            )
            let latestVitalSigns = [];

            if (vitalSignsCategory) {
              const { code, document, unit, effectiveDateTime } = vitalSignsCategory;

              // Combine code and effectiveDateTime into a single array of objects
              const combined = code.map((c, index) => ({
                code: c,
                value: c == 'Blood Pressure' ? `${document[index].component[1].valueQuantity.value}/${document[index].component[2].valueQuantity.value}` :
                  c == 'Body height' || c == 'Body weight' || c == 'Body Temperature' ? document[index].valueQuantity.value : '',
                unit: c == 'Blood Pressure' ? document[index].component[1].valueQuantity.unit : c == 'Body height' || c == 'Body weight' || c == 'Body Temperature' ? document[index].valueQuantity.unit : '',
                effectiveDateTime: effectiveDateTime[index] // Convert to Date for sorting
              }));
              // Sort by effectiveDateTime in descending order
              combined.sort((a, b) => b.effectiveDateTime - a.effectiveDateTime);

              // Extract the latest unique code entries
              const seenCodes = new Set();
              const latestVitalSigns = combined.filter(entry => {
                if (!seenCodes.has(entry.code)) {
                  seenCodes.add(entry.code);
                  return true;
                }
                return false;
              }).map(entry => ({
                code: entry.code,
                value: entry.value,
                unit: entry.unit,
                effectiveDateTime: entry.effectiveDateTime // Convert back to string if needed
              }));
              this.vitalSignsList = latestVitalSigns
            }
          }
          else {
            console.log("entered-2")
            tree.observationValue[visitNo + patientId] = false
          }


        })
        .catch((err) => {
          console.log("Error", err)
        })
    },
    async closePopover(id) {
      document.getElementById(id)
        ? document.getElementById(id).hidePopover()
        : null;
    },
    async openChangeStatusmodalforactivity(
      actScheduleId,
      status,
      patientId,
      visitNo,
      visitName,
      vIndex,
      sheduleId,
      popoverId,
      treeKey = "enter"
    ) {
      await this.closePopover(popoverId);
      this.activitystatusreload.patientId = patientId;
      this.activitystatusreload.visitNo = visitNo;
      this.activitystatusreload.visitName = visitName;
      this.activitystatusreload.sheduleId = sheduleId;
      this.activitystatusreload.vIndex = vIndex;
      this.activitystatusreload.treeKey = treeKey;
      this.selectedTreeKey = treeKey;
      this.selectedActivityid = actScheduleId;
      this.currentactivitystatus = status;
      this.showChangeActivity = true;
    },
    async closeChangeactivityModal() {
      this.showChangeActivity = false;
    },
    async changedactivityStatus(activitystatusreload) {
      this.getactivities(
        activitystatusreload.patientId,
        activitystatusreload.visitNo,
        activitystatusreload.visitName,
        activitystatusreload.vIndex,
        activitystatusreload.sheduleId,
        undefined,
        undefined,
        activitystatusreload.treeKey || this.selectedTreeKey
      );
      this.showChangeActivity = false;
    },
    async openChangeStatusmodal(studyId, visitNo, patientId, status, index, statusType, id, visitName, formStatus, formId, scheduleId, treeKey = "enter") {
      await this.closePopover(id)
      this.selectedForm = formId
      this.scheduleId = scheduleId
      this.statusType = statusType
      this.selectedTreeKey = treeKey;
      this.changeStatus = {
        studyId: studyId,
        visitNo: visitNo,
        subjectId: patientId,
        visitstatus: statusType == 'Visit' ? status : formStatus,
        treeKey: treeKey
      }
      this.formIndex = index
      this.selectedVisitName = visitName
      this.visitIndex = index;
      this.showChangeSchedule = true;
    },
    popoverId(svisit, sIndex, pIndex, vIndex, treeKey = "enter") {
      return this.treePopoverId(treeKey, "menu", svisit, sIndex, pIndex, vIndex);
    },
    activityInputId(sa, patient, visit) {
      return `act-${sa.activityId}-${patient.patientId}-${visit.visitNo}-${sa.activityOrder}`;
    },
    formInputId(singlevisit, pIndex, vIndex, activityindex) {
      return `form-${singlevisit.sheduleId}-${pIndex}-${vIndex}-${activityindex}`;
    },
    async closeChangeScheduleModal() {
      this.showChangeSchedule = false;
    },
    async changedStatus() {
      const treeKey = this.changeStatus.treeKey || this.selectedTreeKey || "enter";
      if (this.statusType == 'Visit') {
        await this.getVisits(this.changeStatus.subjectId, this.visitIndex, treeKey);
      }
      else {
        await this.getVisits(this.changeStatus.subjectId, this.visitIndex, treeKey);
        await this.getFormsByVisit(this.changeStatus.subjectId, this.changeStatus.visitNo, this.selectedVisitName, this.visitIndex, null, null, null, null, treeKey)
      }
    },
    loadPage: function (page) {
      this.currentoverduePage = page;
      this.pageoverdueindex = this.currentoverduePage;
      this.getoverduevisits();
    },
    loadPlanned: function (page) {
      this.currentplannedPage = page;
      this.pageplannedindex = this.currentplannedPage;
      this.getplannedvisits();
    },
    loadForm: function (page) {
      this.currentformPage = page;
      this.pageformindex = this.currentformPage;
      this.getForms();
    },
    loadrecentForm: function (page) {
      this.currentRecentformPage = page;
      this.recentpageformindex = this.currentRecentformPage;
      this.GetRecentFormData();
    },
    openManageVisitPopupNew(item) {
      console.log("manage visit item is ", item);
      this.managevisitobj = item;
      this.showManageVisitModal = true;
    },
    closeManageVisitModalNew() {
      this.showManageVisitModal = false;
    },
    openUnscheduledVisitModal(item) {
      console.log("unscheduled visit item is ", item);
      this.patientId = item.patientId;
      this.showUnscheduledVisitModal = true;
    },
    closeUnscheduledVisitModal() {
      this.showUnscheduledVisitModal = false;
    },
    async refreshVisits() {
      await this.getVisits(this.selectedSubject, this.visitIndex, this.selectedTreeKey || "enter");
    }
  },
};
